/**
 * Color utility functions for consistent color usage across the app
 */

/**
 * Get rgba string for brand colors with custom opacity
 * Usage: rgba(${brandGreen}, 0.5) in inline styles or template literals
 */
export const brandGreen = 'var(--brand-green-rgb)';
export const brandRed = 'var(--brand-red-rgb)';
export const brandDark = 'var(--brand-dark-rgb)';

/**
 * Get hex color for brand colors
 * Usage: Direct hex values for SVG fills, canvas, etc.
 */
export const brandColors = {
  green: '#41FF41',
  red: '#FF5555',
  dark: '#0D0D0E',
} as const;

/**
 * Get option color based on type
 */
export function getOptionColor(optionType: 'CALL' | 'PUT'): string {
  return optionType === 'CALL' ? brandColors.green : brandColors.red;
}

/**
 * Get price direction color
 */
export function getPriceColor(direction: 'up' | 'down'): string {
  return direction === 'up' ? brandColors.green : brandColors.red;
}

/**
 * Get rgba color string for inline styles
 * @param rgbVar - RGB variable string like 'var(--brand-green-rgb)'
 * @param opacity - Opacity value between 0 and 1
 */
export function rgba(rgbVar: string, opacity: number): string {
  return `rgba(${rgbVar}, ${opacity})`;
}

/**
 * Get rgba color string using brand color directly
 * @param color - Color name ('green', 'red', 'dark')
 * @param opacity - Opacity value between 0 and 1
 */
export function brandRgba(
  color: 'green' | 'red' | 'dark',
  opacity: number,
): string {
  const rgbMap = {
    green: brandGreen,
    red: brandRed,
    dark: brandDark,
  };
  return rgba(rgbMap[color], opacity);
}
